import { Routes } from '@angular/router';
import { ESTUDIO_DATOS_PROYECTO_ROUTES } from './tab-datos-proyecto/datos-proyecto.routes';
import { TabDatosProyectoComponent } from './tab-datos-proyecto/tab-datos-proyecto.component';
import { TabDescargarComponent } from './tab-descargar/tab-descargar.component';
import { TabDocumentosEmitidosComponent } from './tab-documentos-emitidos/tab-documentos-emitidos.component';
import { TabParticipacionCiudadanaComponent } from './tab-participacion-ciudadana/tab-participacion-ciudadana.component';

export const ESTUDIO_ROUTES: Routes = [
    {
        path: 'proyecto',
        component: TabDatosProyectoComponent,
        children : ESTUDIO_DATOS_PROYECTO_ROUTES
    },
    { path: 'descargas', component: TabDescargarComponent },
    { path: 'documentos', component: TabDocumentosEmitidosComponent },
    { path: 'participacion', component: TabParticipacionCiudadanaComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'proyecto' }
];
